import { useEffect } from 'react';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import type { State } from '../../../reducers';
import type { FunctionProperties, NonFunctionProperties } from '../../../utils/util';
import { showWorkingTimesInfoBox, widgetActions } from '../redux/widget.redux';
import type { PersistedWidgetState } from './localStorageMapper';
import { localStorageOfWidget } from './storageForWidget';

interface WidgetLocalStorageUpdaterProps {
    shouldShowWorkingTimesInfoBox: boolean;
    setShowWorkingTimesInfoBox: (value: boolean) => void;
}

const widgetStateStorageKey = 'widgetState';

const WidgetLocalStorageUpdater = (props: WidgetLocalStorageUpdaterProps): null => {
    const { shouldShowWorkingTimesInfoBox, setShowWorkingTimesInfoBox } = props;

    const updateReduxStore = (persistedWidgetState: PersistedWidgetState): void => {
        setShowWorkingTimesInfoBox(persistedWidgetState.showWorkingTimesInfoBox);
    };

    useEffect(() => {
        const persistedWidgetState = localStorageOfWidget.loadPersistedWidgetState(widgetStateStorageKey);
        if (persistedWidgetState !== undefined) {
            updateReduxStore(persistedWidgetState);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        localStorageOfWidget.savePersistedWidgetState(widgetStateStorageKey, {
            showWorkingTimesInfoBox: shouldShowWorkingTimesInfoBox,
        });
    }, [shouldShowWorkingTimesInfoBox]);
    return null;
};

const mapDispatchToProps = (dispatch: Dispatch): FunctionProperties<WidgetLocalStorageUpdaterProps> => ({
    setShowWorkingTimesInfoBox: (value: boolean): void => {
        dispatch(widgetActions.setShowWorkingTimesInfoBox(value));
    },
});

const mapStateToProps = (state: State): NonFunctionProperties<WidgetLocalStorageUpdaterProps> => ({
    shouldShowWorkingTimesInfoBox: showWorkingTimesInfoBox(state),
});

export const WidgetLocalStorageUpdaterContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(WidgetLocalStorageUpdater);
